import { render, staticRenderFns } from "./TDelimiter.vue?vue&type=template&id=54418e52&scoped=true"
import script from "./TDelimiter.vue?vue&type=script&lang=js"
export * from "./TDelimiter.vue?vue&type=script&lang=js"
import style0 from "./TDelimiter.vue?vue&type=style&index=0&id=54418e52&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54418e52",
  null
  
)

export default component.exports